const ageFilterKey = 'jig-ageFilter';

class AgeFilter extends HTMLElement {
  static observedAttributes = ["activate"];

  constructor() {
    super();

    this.interceptLink = this.interceptLink.bind(this);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "activate" && newValue !== oldValue && newValue === 'true') {
      this.onLoad();
    }
  }

  connectedCallback() {
    if (this.getAttribute('activate') === 'true') this.onLoad();
  }

  disconnectedCallback() {
    document.body.removeEventListener('click', this.interceptLink);
  }

  checkStorage () {
    let storage = localStorage.getItem(ageFilterKey);
    if (storage) {
      this.selectedRanges = JSON.parse(storage);
    }
  }

  updateFeaturedCollections () {
    document.querySelectorAll('.featured-collection')
      .forEach((collection) => this.filterFeaturedCollection(collection));
  }

  onLinkReset () {
    const params = new URLSearchParams(window.location.search);
    if (params.get('age-reset') === 'true') {
      this.selectedRanges = [];
      localStorage.removeItem(ageFilterKey);
      window.location.href = window.location.origin;
    }
  }

  onLoad () {
    this.selectedRanges = [];

    this.checkStorage();
    this.updateFeaturedCollections();

    document.body.addEventListener('click', this.interceptLink);

    this.onLinkReset();

    if (this.selectedRanges.length === 0 && window.location.href.indexOf('/product') > -1) this.onLoadPDP();
  }

  onLoadPDP () {
    // try to find products age range
    const productSection = document.querySelector('.main-product-section');
    const productAgeRange = productSection && productSection.dataset.ageRange;

    if (productAgeRange) {
      this.selectedRanges = JSON.parse(productAgeRange);
      document.querySelectorAll('.featured-collection')
        .forEach((collection) => this.filterFeaturedCollection(collection));
    }
  }

  // Public API used by the collection-page filter panel (see collection-age-filter.js)
  // to record a selection and re-filter the page, without needing a popup to drive it.
  getSelectedRanges () {
    return this.selectedRanges || [];
  }

  selectRanges (ranges, href = window.location.href) {
    this.selectedRanges = [];

    ranges.forEach((filter) => {
      this.selectedRanges.push(filter);
    });

    localStorage.setItem(ageFilterKey, JSON.stringify(this.selectedRanges));
    this.updateFeaturedCollections();
    document.dispatchEvent(new CustomEvent('age-filter:change', { detail: { ranges: this.selectedRanges } }));
    this.updateSearchParams(this.selectedRanges, href);
  }

  async interceptLink (e) {
    const link = e.target.closest('a');

    if (!link || link.href.indexOf('#search') > -1) return;
    e.preventDefault();

    if (link.href.indexOf('/collection') > -1 || link.href.indexOf('/product') > -1) {
      this.updateSearchParams(this.selectedRanges, link.href);
    } else {
      window.location.href = link.href;
    }
  }

  async filterFeaturedCollection (el) {
    const url = new URL(el.dataset.collectionUrl);
    const limit = Number(el.dataset.productsLimit);

    if (this.selectedRanges[0] === 'all') return;

    for (let filter of this.selectedRanges) {
      url.searchParams.append('filter.p.m.custom.age_range', filter);
    }

    const html = await this.fetchFilteredCollectionListHTML(url.toString());
    let output = ''
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    let count = 0;

    doc.querySelectorAll('li.grid__item').forEach((item) => {
      if (count >= limit) return;

      if (!this.dataset.product || item.dataset.productId !== this.dataset.product) {
        output += item.outerHTML;
        count++;
      }
    });

    el.innerHTML = output;
  }

  fetchFilteredCollectionListHTML (url) {
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then(htmlString => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        return doc.querySelector('#product-grid').innerHTML;
      })
  }

  updateSearchParams (filters, href = window.location.href) {
    const url = new URL(href);

    if (filters[0] === 'all') {
      // "Show all" clears every storefront filter, not just the age range
      Array.from(url.searchParams.keys())
        .filter((key) => key.startsWith('filter.'))
        .forEach((key) => url.searchParams.delete(key));
    } else {
      url.searchParams.delete('filter.p.m.custom.age_range')

      for (let filter of filters) {
        url.searchParams.append('filter.p.m.custom.age_range', filter)
      }
    }

    window.location.href = url.toString();
  }
}


customElements.define('age-filter', AgeFilter);
